__turbopack_context__.v({
  "continueWithEmailLink": "styles-module__a6SmLa__continueWithEmailLink",
  "wrapper": "styles-module__a6SmLa__wrapper",
});
